import React, {Dispatch, SetStateAction, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import api from "../../../../api";

function SelectWordBin({
                                setShowWordBin,
                                selectedWordBins,
                                selectedWordBinGroup
                           }: {
    setShowWordBin: Dispatch<SetStateAction<boolean>>,
    selectedWordBins: any[],
    selectedWordBinGroup:number
}) {
    const [selectedWordBin,setSelectedWordBin]=useState<number>(selectedWordBins[0].Id);

    const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        setSelectedWordBin(parseInt(value));
    };

    const clickConfirm=()=>{
         api.reactionLists.addToGroup(selectedWordBin,selectedWordBinGroup);
        setShowWordBin(false);
    }

    return(
        <>
            <div id={"new-group-name-modal"}>
                <p className={"new-group-name-modal-label"}>
                        <span>
                            <FontAwesomeIcon icon={faQuestionCircle} />
                            <i>Please select a word bin you want to add to the group:</i>
                        </span>
                </p>

                <select onChange={selectChange}>
                    {selectedWordBins.map(item =>
                        <option value={item.Id}>{item.Description}</option>
                    )}
                </select>


                <div id={"btn-split-new-group"}>
                    <button onClick={()=>setShowWordBin(false)} id={"button-cancel-new-group"}>
                        Cancel
                    </button>
                    <button onClick={clickConfirm} >
                        Confirm
                    </button>
                 </div>

            </div>
        </>
    )
}

export default SelectWordBin;